import {Box} from '@mui/material'
import PropTypes from 'prop-types'
import {StyledSectionTitle, StyledTextContent} from '../../AdminPanelStyling'
import MultiSelectDropdownComponent from '../../common/MulitSelectDropdown/MultiSelectDropdownComponent'

const Benefits = ({benefits, selectedData, setSelectedData}) => {
  const renderDropdown = () => {
    return (
      <MultiSelectDropdownComponent
        selectAllTitle='Select All'
        dropDownTitle='Select Benefit'
        inputAndPreviewTitle='Benefits Programs'
        dropDownModifiedTitle='Selected Benefits'
        dropDownData={benefits}
        val={selectedData}
        setVal={setSelectedData}
        conditionalProps={{isOptionEqualToValue: (option, value) => option.id === value.id}}
      />
    )
  }

  return (
    <Box tabIndex={0} aria-label='Benefits Eligibility Section'>
      <StyledSectionTitle variant='h5' tabIndex={0}>
        {'What Benefits Programs do you want Available?'}
      </StyledSectionTitle>
      <StyledTextContent tabIndex={0}>
        Benefits Program displays who is eligible for benefits such as SNAP and Public Health Insurance.
      </StyledTextContent>
      {renderDropdown()}
    </Box>
  )
}

Benefits.propTypes = {
  benefits: PropTypes.array.isRequired,
  selectedData: PropTypes.array.isRequired,
  setSelectedData: PropTypes.func.isRequired
}

export default Benefits
